import { useQuery } from "react-query";
import axios from "axios";

const baseUrl = "https://greendesign.netbaseteam.com/rest/V1/salerep";
const token = "tajbcwlgromlq2u32q794f7gmrzp724r";

export const useFetchReports = (filters) => {
  const fetchReports = async () => {
    let url = "";

    if (filters.length) {
      let params = "";
      filters.forEach((filter, index) => {
        if (filter.key === "link") {
          url = filter.value;
        } else if (index === 0) {
          params += `${filter.key}=${filter.value}`;
        } else {
          params += `&${filter.key}=${filter.value}`;
        }
      });
      if (!url) url = `${baseUrl}?${params}`;
    } else {
      url = baseUrl;
    }

    try {
      const { data } = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return data[0];
    } catch (error) {
      throw new Error(error.message);
    }
  };

  return useQuery(["reports", { filters }], fetchReports);
};

export const useFetchOrders = () => {
  const fetchReports = async () => {
    const url = "https://greendesign.netbaseteam.com/rest/V1/salereporder";

    try {
      const { data } = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return data[0];
    } catch (error) {
      throw new Error(error.message);
    }
  };

  return useQuery(["orders"], fetchReports);
};
